import React, { useEffect, useState } from "react";
import CustomDatePicker from "../../components/CustomDatePicker";
import MyAccountFilter from "../MyAccount/MyAccountFilter";
import { useRef } from "react";
import Select from "react-select";
import moment from "moment";
import { apiPath } from "../../Utils/apiPath";
import { apiGet } from "../../Utils/apiFetch";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { toFixedWithoutRounding } from "../../Utils/Constant";
const ReaportByAllCasino = () => {
  const previousDate = moment()
    .subtract(1, "day")
    .format("YYYY-MM-DD HH:mm:ss");
  const currentDate = moment().format("YYYY-MM-DD HH:mm:ss");
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const tableRef = useRef();
  const [data, setData] = useState([]);
  const DEFAULT_FILTER = {
    fromPeriod: previousDate,
    toPeriod: currentDate,
  };
  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const getData = async (activeFilter) => {
    const path = apiPath.profitReportByAllCasino;
    const { status, data: response_users } = await apiGet(path, activeFilter);
    if (status === 200 && response_users.success) {
      setData(response_users.results[0] || []);
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter]);

  const applyPreset = (preset) => {
    const nextFilter = { ...filter, page: 1, filterByDay: preset };
    if (preset === "today") {
      nextFilter.fromPeriod = moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      nextFilter.toPeriod = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    } else if (preset === "yesterday") {
      nextFilter.fromPeriod = moment()
        .subtract(1, "day")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      nextFilter.toPeriod = moment()
        .subtract(1, "day")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    setFilter(nextFilter);
    getData(nextFilter);
  };

  return (
    <app-global-report _nghost-serverapp-c117 className="ng-star-inserted">
      <div _ngcontent-serverapp-c117 className="main_wrap">
        <div _ngcontent-serverapp-c117 className="box">
          <h2 _ngcontent-serverapp-c117>Profit/Loss Report by All Casino</h2>
          <h2 _ngcontent-serverapp-c117 className="push" />
        </div>
        <ul _ngcontent-serverapp-c117 className="report-tab-wrap">
          <li
            _ngcontent-serverapp-c117
            id="reportType_exchange"
            data-reporttabtype={0}
            className="report-tab select"
          >
            <a _ngcontent-serverapp-c117>All</a>
          </li>
        </ul>
        <div _ngcontent-serverapp-c117 className="function-wrap">
          <ul _ngcontent-serverapp-c117 className="input-list flowroot">
            <li _ngcontent-serverapp-c117>
              <label _ngcontent-serverapp-c117>Period</label>
            </li>
            <CustomDatePicker filter={filter} setFilter={setFilter} />
            <li>
              <input
                name="sortCondition"
                placeholder="Search Market"
                value={filter.market}
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, market: e.target.value }))
                }
              />
            </li>
            <li>
              <input
                placeholder="Search Event"
                value={filter.event}
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, event: e.target.value }))
                }
              />
            </li>
          </ul>
          <ul className="input-list flowroot">
            <li>
              <a
                id="today"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("today");
                }}
              >
                Just for today
              </a>
            </li>
            <li>
              <a
                id="yesterday"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("yesterday");
                }}
              >
                From yesterday
              </a>
            </li>
            <li>
              <a
                id="getPL"
                className="btn-send"
                onClick={(e) => {
                  e.preventDefault();
                  getData(filter);
                }}
              >
                Get P &amp; L
              </a>
            </li>
          </ul>
        </div>
        <div _ngcontent-serverapp-c117 id="noReportMessage" />
        <div _ngcontent-serverapp-c117 id="userTreeDiv" className="total_all">
          <div _ngcontent-serverapp-c117 id="treePath" className="agent_path" />

          {/* <span>
            <label>Last:</label>
            <select
              name="limit"
              id="limit"
              value={filter.limit}
              onChange={handleLimitChange}
            >
              <option value={100}>100 Txn</option>
              <option value={50}>50 Txn</option>
              <option value={25}>25 Txn</option>
              <option value={10}>10 Txn</option>
            </select>
          </span> */}
          <span _ngcontent-serverapp-c117 className="spacer" />

          <MyAccountFilter
            type={"new"}
            tableRef={tableRef}
            fileName="report-allCasino"
          />
        </div>
        <div
          _ngcontent-serverapp-c122
          id="reportDiv"
          className="over-wrap"
          style={{ "max-height": "calc(100% - 32px - 93px - 55px)" }}
        >
          <div
            _ngcontent-serverapp-c122
            className="table-responsive data-table"
          >
            <table
              ref={tableRef}
              _ngcontent-serverapp-c122
              id="table_DL"
              className="table01 table-pt"
            >
              <tbody _ngcontent-serverapp-c122>
                <tr _ngcontent-serverapp-c122 id="table_DL">
                  <th
                    _ngcontent-serverapp-c122
                    id="header_userName"
                    width="15%"
                    data-order="asc"
                    data-name="userName"
                    className="align-L sort_asc"
                  >
                    Provider
                  </th>
                  <th
                    _ngcontent-serverapp-c122
                    id="header_tax_agent_2"
                    width="10%"
                    data-order="asc"
                    data-name="stake"
                    className="sort_asc"
                  >
                    Total stake.
                  </th>
                  <th
                    _ngcontent-serverapp-c122
                    width="20%"
                    data-order="asc"
                    data-name="playerPL"
                    className="sort_asc"
                  >
                    Player P/L{" "}
                  </th>
                  <th
                    _ngcontent-serverapp-c122
                    id="header_profitLoss_downLine"
                    width="13%"
                    data-order="asc"
                    data-name="downlinePL"
                    className="sort_asc"
                  >
                    {" "}
                    Downline P/L{" "}
                  </th>
                  <th
                    _ngcontent-serverapp-c122
                    width="15%"
                    data-order="asc"
                    data-name="uplinePL"
                    className="sort_asc"
                  >
                    Upline P/L{" "}
                  </th>
                </tr>
              </tbody>
              <tbody _ngcontent-serverapp-c122 id="content">
                <tr _ngcontent-serverapp-c122 id="table_DL">
                  <td _ngcontent-serverapp-c122 className="align-L">
                    <span
                      _ngcontent-serverapp-c122
                      className="Bdlevel lv_ premium"
                    />
                    AWC{" "}
                  </td>
                  <td _ngcontent-serverapp-c122 id="_tax2">
                    <div _ngcontent-serverapp-c122>
                      <span _ngcontent-serverapp-c122>
                        {" "}
                        {toFixedWithoutRounding(data?.stakeAmount)}{" "}
                      </span>
                    </div>
                  </td>
                  <td _ngcontent-serverapp-c122 id="_profitLoss">
                    <div _ngcontent-serverapp-c122>
                      <span
                        _ngcontent-serverapp-c122
                        className={data?.amount > 0 ? "win-text" : "loss-text"}
                      >
                        {toFixedWithoutRounding(data?.amount)}
                      </span>
                    </div>
                  </td>
                  <td _ngcontent-serverapp-c122>
                    <div _ngcontent-serverapp-c122>
                      <span _ngcontent-serverapp-c122>0.00</span>
                    </div>
                  </td>
                  <td _ngcontent-serverapp-c122 id="_profitLossUpLine">
                    <div _ngcontent-serverapp-c122>
                      <span _ngcontent-serverapp-c122>      {toFixedWithoutRounding(Math.abs(data?.amount))}</span>
                    </div>
                  </td>
                </tr>

                <tr _ngcontent-serverapp-c122 className="total">
                  <td _ngcontent-serverapp-c122 className="align-L">
                    Total
                  </td>
                  <td _ngcontent-serverapp-c122 id="_totalComm">
                    <span _ngcontent-serverapp-c122>
                      {toFixedWithoutRounding(data?.stakeAmount)}{" "}
                    </span>
                  </td>
                  <td _ngcontent-serverapp-c122>
                    <div _ngcontent-serverapp-c122>
                      <span
                        _ngcontent-serverapp-c122
                        className={data?.amount > 0 ? "win-text" : "loss-text"}
                      >
                        {toFixedWithoutRounding(data?.amount)}
                      </span>
                    </div>
                  </td>
                  <td _ngcontent-serverapp-c122 id="_totalDownlinePl">
                    <span _ngcontent-serverapp-c122> 0.00 </span>
                  </td>
                  <td _ngcontent-serverapp-c122 id="_totalUplinePL">
                    <span _ngcontent-serverapp-c122>      {toFixedWithoutRounding(Math.abs(data?.amount))}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </app-global-report>
  );
};

export default ReaportByAllCasino;
const userOptions = [
  { value: "1", label: "User 1" },
  { value: "2", label: "User 2" },
  { value: "3", label: "User 3" },
];
